import React from 'react';
const stats = [{
  value: '20+',
  label: 'Countries with planners using the system'
}, {
  value: '6 + 5',
  label: 'Volumes and field tools'
}, {
  value: '4.9/5',
  label: 'Average rating'
}, {
  value: 'End to end',
  label: 'From first inquiry to final referral'
}];
export function SocialProofBar() {
  return <section aria-label="Social proof" className="w-full bg-ink text-ivory" data-id="element-212" data-mp="25tvivde7c800">
      <div className="mx-auto grid max-w-6xl grid-cols-2 gap-y-8 px-5 py-10 sm:grid-cols-4 sm:divide-x sm:divide-gold/25" data-id="element-213" data-mp="32jmr0fff1toa">
        {stats.map(stat => <div key={stat.label} className="px-4 text-center" data-id="element-214" data-mp="2xhxdmt4q13x1">
            <div className="font-serif text-2xl sm:text-3xl text-gold" data-id="element-215" data-mp="2thdi1tzsq8d0">{stat.value}</div>
            <div className="mt-2 text-[11px] uppercase tracking-[0.16em] text-ivory/60" data-id="element-216" data-mp="2ok4utezsje4w">
              {stat.label}
            </div>
          </div>)}
      </div>
    </section>;
}